import { render, staticRenderFns } from "./SubjectPreview.vue?vue&type=template&id=2e2a8350&scoped=true&"
import script from "./SubjectPreview.vue?vue&type=script&lang=js&"
export * from "./SubjectPreview.vue?vue&type=script&lang=js&"
import style0 from "./SubjectPreview.vue?vue&type=style&index=0&id=2e2a8350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a8350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VIcon,VSheet,VTooltip})
